import { call, put, takeLatest, delay } from "redux-saga/effects";
import axios from "axios";
import {
  blockNumberRequest,
  blockNumberSuccess,
  blockNumberFailure,
  fetchBlockListRequest,
  fetchBlockListSuccess,
  fetchBlockListFailure,
  deleteBlockNumberRequest,
  deleteBlockNumberSuccess,
  deleteBlockNumberFailure,
} from "./BlocklistSlice";
//delete number
function* deleteBlockNumberSaga(action) {
  try {
    const response = yield call(
      axios.delete,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/blocklist/deleteFromBlockList/${action.payload}`
    );

    if (response.data.success) {
      yield put(deleteBlockNumberSuccess(action.payload));
      yield put(fetchBlockListRequest());
    } else {
      yield put(
        deleteBlockNumberFailure(response.data.message || "Failed to delete.")
      );
    }
  } catch (error) {
    yield put(
      deleteBlockNumberFailure(error.response?.data?.message || error.message)
    );
  }
}

// Create blocklist number
function* blockNumberSaga(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/blocklist/blockNumber`,
      action.payload
    );

    const resData = response.data;
    if (resData.success) {
      yield put(blockNumberSuccess({ message: resData.message }));
      yield put(fetchBlockListRequest());
    } else {
      yield put(blockNumberFailure(resData.message || "Unknown error"));
    }
  } catch (error) {
    yield put(
      blockNumberFailure(error.response?.data?.message || error.message)
    );
  }
}

// Fetch blocklist
function* fetchBlockListSaga(action) {
  try {
    const { start = 0, limit = 10, search = "" } = action.payload || {};

    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/blocklist/getBlockList`,
      {
        params: { start, limit, search },
      }
    );

    const result = response.data;

    const data = Array.isArray(result.data?.data)
      ? result.data.data.map((user, index) => ({
          id: start + index + 1,
          jeweller: user.jeweller,
          enable: user.enable,
          phone: user.phone,
          type: user.type,
          createdAt: user.createdAt,
          updatedAt: user.updatedAt,
          createdBy: user.createdBy || "",
        }))
      : [];

    const total = result.data?.total || 0;

    yield put(fetchBlockListSuccess({ data, total }));
  } catch (error) {
    yield put(fetchBlockListFailure(error.message));
  }
}

export function* BlocklistSaga() {
  yield takeLatest(blockNumberRequest.type, blockNumberSaga);
  yield takeLatest(fetchBlockListRequest.type, fetchBlockListSaga);
  yield takeLatest(deleteBlockNumberRequest.type, deleteBlockNumberSaga);
}
